export const isRightClick = (event: MouseEvent | PointerEvent | TouchEvent): boolean => {
  return 'which' in event
    ? event.which === 3
    : 'button' in event
    ? (event as any).button === 2
    : false;
};

export default isRightClick;
